import { useCallback, useRef } from 'react';

import {
  createMathJaxTimer,
  trackMathJaxInitialization,
} from '../../../utils/newrelic-mathjax';

export const useMathJaxScript = (
  onLoad: () => void,
  addManagedEventListener: (_event: string, _handler: EventListener) => void
) => {
  const isInitialized = useRef(false);

  const handleScriptLoad = useCallback(() => {
    if (isInitialized.current || typeof window === 'undefined') return;

    const initTimer = createMathJaxTimer();
    isInitialized.current = true;
    const loadTime = initTimer.end();
    trackMathJaxInitialization.success('cdn', loadTime);

    if (document.readyState === 'loading') {
      const domContentLoadedHandler = () => {
        setTimeout(() => onLoad(), 100);
      };
      addManagedEventListener('DOMContentLoaded', domContentLoadedHandler);
    } else {
      setTimeout(() => onLoad(), 100);
    }

    window.dispatchEvent(new CustomEvent('mathjax-ready'));
  }, [onLoad, addManagedEventListener]);

  const handleScriptError = useCallback(() => {
    console.error('❌ Failed to load MathJax from CDN');
    trackMathJaxInitialization.failure(
      'cdn',
      new Error('Failed to load MathJax from CDN'),
      false
    );
  }, []);

  return { handleScriptError, handleScriptLoad, isInitialized };
};